module.exports = __webpack_public_path__ + "static/media/coming-soon.94209809.jpg";